import React from 'react';

const BadgeCondition = ({order, _id}) => {
    if (order.recieverStep === -1 || order.senderStep === -1) {
        return (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                CANCELED: Click for details
            </span>
        );
    };

    if (order.reciever === _id) {

        if (order.recieverPaymentStatus !== 'succeeded') {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                    Waiting for payment
                </span>
            );
        }


        if (order.recieverStep === 0) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                    Waiting for payment
                </span>
            );
        }
        else if (order.recieverStep === 1) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    Waiting for other user to ship
                </span>
            );
        }
        else if (order.recieverStep === 2) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    Shipping to verification center
                </span>
            );
        }
        else if (order.recieverStep === 3) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    At verification center
                </span>
            );
        }
        else if (order.recieverStep === 4) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    Shipping to you
                </span>
            );
        }
        else if (order.recieverStep === 5) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Arrived!
                </span>
            );
        }
        else {
            return (<> </>);
        }
    }
    else { //if sender

        if (order.senderPaymentStatus !== 'succeeded') {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                    Waiting for payment
                </span>
            );
        }

        if (order.senderStep === 0) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                    Waiting for payment
                </span>
            );
        }
        else if (order.senderStep === 1) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    Waiting for other user to ship
                </span>
            );
        }
        else if (order.senderStep === 2) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    Shipping to verification center
                </span>
            );
        }
        else if (order.senderStep === 3) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    At verification center
                </span>
            );
        }
        else if (order.senderStep === 4) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    Shipping to you
                </span>
            );
        }
        else if (order.senderStep === 5) {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Arrived!
                </span>
            );
        }
        else {
            return (<> </>);
        }

    }
};

export default BadgeCondition;

